
export enum CharMenuState {
  PlayerSel = "Player",
  CountingDown = "CountingDown",
  ComNumSel = "ComNumberSel",
  ComSel = "Computer",
  GameSetting = "GameSetting"
}
